import { useState } from "react";
import LBox from "@components/LBox";
import LPressable from "@components/LPressable";
import LText from "@components/LText";
import { RichText } from "@libs/shared-ui/native";

const Paragraph = ({ children }: { children: React.ReactNode }) => (
  <LText variant="Body/B1/Regular" color="white" opacity={0.85}>
    {children}
  </LText>
);

/** Matches the Link-in-Bio sheet: the description sits under the line-up,
 *  formatted (markdown-lite), clamped to a few lines with Read more. */
const Description = ({ text }: { text: string | null }) => {
  const [open, setOpen] = useState(false);
  const [clamped, setClamped] = useState(false);
  if (!text) return null;
  return (
    <LBox gap="s2">
      <LBox
        style={open ? undefined : { maxHeight: 72, overflow: "hidden" }}
        onLayout={(e) => {
          if (!open && e.nativeEvent.layout.height >= 72) setClamped(true);
        }}
      >
        <RichText markdown={text} Paragraph={Paragraph} linkColor="white" />
      </LBox>
      {clamped || open ? (
        <LPressable
          onPress={() => setOpen((o) => !o)}
          sentryEventName="AccessDetail.Description.ReadMore"
        >
          <LText variant="Body/B2/SemiBold" color="lightGrey">
            {open ? "Show less" : "Read more"}
          </LText>
        </LPressable>
      ) : null}
    </LBox>
  );
};

export default Description;
